import React from "react";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { PAGE_NAME, ROUTE, saasToolName, SOMETHING_WENT_WRONG, SubscriptionsName } from "../../../../../constants/constants";
import { Dropdown } from "../../../../atoms/dropdown";
import { DropdownOptionsType, payloadType } from "../../../../../types";
import { Input } from "../../../../atoms/input";
import { useCreateLicenseMutation, useSingleLicenseQuery, useUpdateLicenseMutation } from "../../../../../store/license/licenseSlice";
import { useOktaGroupListQuery } from "../../../../../store/okta/groupSlice";
import { CustomDatePicker } from "../../../../atoms/datePicker";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Switch } from "../../../../atoms/switch";
import { Loader } from "../../../../atoms/loader";

const AddNewSaaSTool = () => {
    const pageClassName = "p-addNewLicense";
    const navigate = useNavigate();
    const url = useLocation();

    const initialState: payloadType = {
        name: {
            value: "",
            error: "",
            isError: false,
        },
        subscription_type: {
            value: "",
            error: "",
            isError: false,
        },
        total: {
            value: "",
            error: "",
            isError: false,
        },
        renewal_date: {
            value: "",
            error: "",
            isError: false,
        },
        group_id: {
            value: "",
            error: "",
            isError: false,
        },
        vendor_contact_name: {
            value: "",
            error: "",
            isError: false,
        },
        vendor_contact_email: {
            value: "",
            error: "",
            isError: false,
        },
        vendor_designation: {
            value: "",
            error: "",
            isError: false,
        },
        distributor_company_name: {
            value: "",
            error: "",
            isError: false,
        },
        distributor_website: {
            value: "",
            error: "",
            isError: false,
        },
        distributor_points_of_contact: {
            value: "",
            error: "",
            isError: false,
        },
        distributor_email_contact: {
            value: "",
            error: "",
            isError: false,
        },
        is_true_up: {
            value: false,
            error: "",
            isError: false,
        },
        true_up_date_q1: {
            value: "",
            error: "",
            isError: false,
        },
        true_up_date_q2: {
            value: "",
            error: "",
            isError: false,
        },
        true_up_date_q3: {
            value: "",
            error: "",
            isError: false,
        },
        true_up_date_q4: {
            value: "",
            error: "",
            isError: false,
        },
        id: {
            value: "",
            error: "",
            isError: false,
        },
    };

    const [payload, setPayload] = React.useState(initialState);

    React.useEffect(() => {
        if (url.pathname === ROUTE.EDIT_SAAS_TOOL && !url?.state?.id) {
            navigate(ROUTE.LICENSE_MANAGEMENT);
        } else if (url.pathname === ROUTE.EDIT_SAAS_TOOL && url?.state?.id) {
            setPayload({
                ...payload,
                id: {
                    ...payload.id,
                    value: url?.state?.id,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url?.state?.id, url?.pathname]);

    const {
        data: singleLicenseData,
        isSuccess: isSingleSuccess,
        isFetching: isSingleFetching,
    } = useSingleLicenseQuery(payload.id.value as number, {
        skip: payload.id.value ? false : true,
    });

    const { data: groupData, isLoading: groupLoading } = useOktaGroupListQuery(
        {}
    );
    const [createApi, { isLoading: createLoading }] = useCreateLicenseMutation();
    const [updateApi, { isLoading: updateLoading }] = useUpdateLicenseMutation();

    React.useEffect(() => {
        if (isSingleSuccess) {
            setPayload({
                ...payload,
                name: {
                    ...payload.name,
                    value: singleLicenseData?.result?.name,
                },
                subscription_type: {
                    ...payload.subscription_type,
                    value: {
                        label: singleLicenseData?.result?.subscriptionType,
                        value: singleLicenseData?.result?.subscriptionType,
                    },
                },
                total: {
                    ...payload.total,
                    value: singleLicenseData?.result?.total,
                },
                vendor_contact_name: {
                    ...payload.vendor_contact_name,
                    value: singleLicenseData?.result?.vendorContactName,
                },
                vendor_contact_email: {
                    ...payload.vendor_contact_email,
                    value: singleLicenseData?.result?.vendorContactEmail,
                },
                vendor_designation: {
                    ...payload.vendor_designation,
                    value: singleLicenseData?.result?.vendorDesignation,
                },
                distributor_company_name: {
                    ...payload.distributor_company_name,
                    value: singleLicenseData?.result?.distributorCompanyName,
                },
                distributor_website: {
                    ...payload.distributor_website,
                    value: singleLicenseData?.result?.distributorWebsite,
                },
                distributor_points_of_contact: {
                    ...payload.distributor_points_of_contact,
                    value: singleLicenseData?.result?.distributorPointsOfContact,
                },
                distributor_email_contact: {
                    ...payload.distributor_email_contact,
                    value: singleLicenseData?.result?.distributorEmailContact,
                },
                is_true_up: {
                    ...payload.is_true_up,
                    value: singleLicenseData?.result?.isTrueUp,
                },
                true_up_date_q1: {
                    ...payload.true_up_date_q1,
                    value: singleLicenseData?.result?.trueUpDateQ1,
                },
                true_up_date_q2: {
                    ...payload.true_up_date_q2,
                    value: singleLicenseData?.result?.trueUpDateQ2,
                },
                true_up_date_q3: {
                    ...payload.true_up_date_q3,
                    value: singleLicenseData?.result?.trueUpDateQ3,
                },
                true_up_date_q4: {
                    ...payload.true_up_date_q4,
                    value: singleLicenseData?.result?.trueUpDateQ4,
                },
                renewal_date: {
                    ...payload.renewal_date,
                    value: singleLicenseData?.result?.renewalDate,
                },
                group_id: {
                    ...payload.group_id,
                    value: {
                        label: singleLicenseData?.result?.group?.name,
                        value: singleLicenseData?.result?.group?.id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSingleSuccess, singleLicenseData]);

    const submitHandler = async (event: React.FormEvent) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append("name", payload.name.value as string);
        payload.total.value &&
            formData.append("total", payload.total.value.toString());
        formData.append("renewal_date", payload.renewal_date.value as string);
        formData.append(
            "group_id",
            (payload.group_id.value as DropdownOptionsType).value as string
        );
        payload.subscription_type.value &&
            formData.append(
                "subscription_type",
                (payload.subscription_type.value as DropdownOptionsType).value as string
            );
        payload.vendor_contact_name.value &&
            formData.append("vendor_contact_name", payload.vendor_contact_name.value as string);
        payload.vendor_contact_email.value &&
            formData.append("vendor_contact_email", payload.vendor_contact_email.value as string);
        payload.vendor_designation.value &&
            formData.append("vendor_designation", payload.vendor_designation.value as string);
        payload.distributor_company_name.value &&
            formData.append("distributor_company_name", payload.distributor_company_name.value as string);
        payload.distributor_website.value &&
            formData.append("distributor_website", payload.distributor_website.value as string);
        payload.distributor_points_of_contact.value &&
            formData.append("distributor_points_of_contact", payload.distributor_points_of_contact.value as string);
        payload.distributor_email_contact.value &&
            formData.append("distributor_email_contact", payload.distributor_email_contact.value as string);
        formData.append("is_true_up", (payload.is_true_up.value ? "1" : "0"));
        payload.true_up_date_q1.value &&
            formData.append("true_up_date_q1", payload.true_up_date_q1.value as string);
        payload.true_up_date_q2.value &&
            formData.append("true_up_date_q2", payload.true_up_date_q2.value as string);
        payload.true_up_date_q3.value &&
            formData.append("true_up_date_q3", payload.true_up_date_q3.value as string);
        payload.true_up_date_q4.value &&
            formData.append("true_up_date_q4", payload.true_up_date_q4.value as string);
        if (payload.id.value) formData.append("id", payload?.id?.value?.toString());

        let response: any;
        if (payload.id.value) {
            response = (await updateApi(formData)) as any;
        } else {
            response = (await createApi(formData)) as any;
        }

        if (response?.data?.success) {
            toast.success(response?.data?.message);
            navigate(ROUTE.LICENSE_MANAGEMENT);
        } else {
            if (response?.error?.data?.errors) {
                Object.keys(response?.error?.data?.errors).forEach((key) => {
                    setPayload((prevState) => ({
                        ...prevState,
                        [key]: {
                            ...prevState[key],
                            error: response?.error?.data?.errors[key][0],
                            isError: true,
                        },
                    }));
                });
            } else {
                toast.error(response?.error.data?.message);
            }
            if (response?.error?.error) {
                toast.error(SOMETHING_WENT_WRONG);
            }
        }
    };

    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>{url?.state?.id ? PAGE_NAME.EDIT_SAAS_TOOL : PAGE_NAME.ADD_SAAS_TOOL}</p>
            <div className={`${pageClassName}__container`}>
                <Loader isLoading={isSingleFetching || groupLoading || createLoading || updateLoading} >
                    <form className={`${pageClassName}__form`} onSubmit={submitHandler}>
                        <div className={`${pageClassName}__form__dropdown`}>
                            <label className={`${pageClassName}__form__dropdown__label`}>
                                Saas Name
                            </label>
                            {payload?.id?.value ? (
                                <div className={`${pageClassName}__form__dropdown__value`}>
                                    <span>{payload?.name?.value as string}</span>
                                </div>
                            ) : (
                                <Dropdown
                                    options={saasToolName.map((tool) => ({
                                        label: tool.label,
                                        value: tool.value,
                                    }))}
                                    onClickChange={(selected) =>
                                        setPayload({
                                            ...payload,
                                            name: {
                                                ...payload.name,
                                                value: selected?.value as string,
                                            },
                                        })
                                    }
                                    placeholder="Please Select a Tool"
                                    isIcon
                                    color="black"
                                    isBordered
                                    // selected={{
                                    //   label: payload.name.value as string,
                                    //   value: payload.name.value as string,
                                    // }}
                                    isError={payload.name.isError}
                                    error={payload.name.error}
                                />
                            )}
                        </div>

                        <div className={`${pageClassName}__form__dropdown`}>
                            <label className={`${pageClassName}__form__dropdown__label`}>
                                Subscription Type
                            </label>
                            <Dropdown
                                options={SubscriptionsName}
                                onClickChange={(selected) =>
                                    setPayload({
                                        ...payload,
                                        subscription_type: {
                                            ...payload.subscription_type,
                                            value: selected as { label: string; value: string },
                                            isError: false,
                                            error: "",
                                        },
                                    })
                                }
                                placeholder="Please Select a Subscription Type"
                                isIcon
                                color="black"
                                isBordered
                                selected={
                                    payload.subscription_type.value as DropdownOptionsType
                                }
                                isError={payload.subscription_type.isError}
                                error={payload.subscription_type.error}
                            />
                        </div>

                        <div className={`${pageClassName}__form__dropdown`}>
                            <label className={`${pageClassName}__form__dropdown__label`}>
                                Okta Group
                            </label>
                            <Dropdown
                                options={groupData?.result?.data?.map((group: any) => ({
                                    label: group?.name,
                                    value: group?.id,
                                }))}
                                onClickChange={(selected) =>
                                    setPayload({
                                        ...payload,
                                        group_id: {
                                            ...payload.group_id,
                                            value: selected as { label: string; value: string },
                                            isError: false,
                                            error: "",
                                        },
                                    })
                                }
                                placeholder="Please Select a Group"
                                isIcon
                                color="black"
                                isBordered
                                selected={payload.group_id.value as DropdownOptionsType}
                                isError={payload.group_id.isError}
                                error={payload.group_id.error}
                            />
                        </div>

                        <Input
                            placeholder="Vendor Contact Name"
                            label="Vendor Contact Name"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    vendor_contact_name: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.vendor_contact_name.value as string) || ""}
                            isError={payload.vendor_contact_name.isError}
                            error={payload.vendor_contact_name.error}
                        />

                        <Input
                            placeholder="Vendor Contact Email"
                            label="Vendor Contact Email"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    vendor_contact_email: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.vendor_contact_email.value as string) || ""}
                            isError={payload.vendor_contact_email.isError}
                            error={payload.vendor_contact_email.error}
                            type="email"
                        />

                        <Input
                            placeholder="Vendor Designation"
                            label="Vendor Designation"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    vendor_designation: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.vendor_designation.value as string) || ""}
                            isError={payload.vendor_designation.isError}
                            error={payload.vendor_designation.error}
                        />

                        <Input
                            placeholder="Distributor Company Name"
                            label="Distributor Company Name"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    distributor_company_name: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.distributor_company_name.value as string) || ""}
                            isError={payload.distributor_company_name.isError}
                            error={payload.distributor_company_name.error}
                        />

                        <Input
                            placeholder="Distributor Website"
                            label="Distributor Website"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    distributor_website: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.distributor_website.value as string) || ""}
                            isError={payload.distributor_website.isError}
                            error={payload.distributor_website.error}
                        />

                        <Input
                            placeholder="Distributor Points of Contact"
                            label="Distributor Points of Contact"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    distributor_points_of_contact: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.distributor_points_of_contact.value as string) || ""}
                            isError={payload.distributor_points_of_contact.isError}
                            error={payload.distributor_points_of_contact.error}
                        />

                        <Input
                            placeholder="Distributor Email Contact"
                            label="Distributor Email Contact"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    distributor_email_contact: {
                                        ...payload.total,
                                        value: e.target.value,
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.distributor_email_contact.value as string) || ""}
                            isError={payload.distributor_email_contact.isError}
                            error={payload.distributor_email_contact.error}
                            type="email"
                        />

                        <div className={`${pageClassName}__form__group__tax`}>
                            <label>Is True Up</label>
                            <div className={`${pageClassName}__form__group__content`}>
                                <Switch
                                    color="blue"
                                    onInputChange={(checked) => {
                                        setPayload({
                                            ...payload,
                                            is_true_up: {
                                                value: checked,
                                                error: "",
                                                isError: false,
                                            },
                                        });
                                    }}
                                    defaultChecked={payload.is_true_up.value as boolean}
                                />
                            </div>
                        </div>

                        {payload.is_true_up.value && (
                            <>
                                <div className={`${pageClassName}__filter__item`}>
                                    <label>1st True Up Date</label>
                                    <CustomDatePicker
                                        value={payload.true_up_date_q1.value ? new Date(payload.true_up_date_q1.value as string) : undefined}
                                        onChange={(date) =>
                                            setPayload({
                                                ...payload,
                                                true_up_date_q1: {
                                                    value: date?.toString() as string,
                                                    isError: false,
                                                    error: "",
                                                },
                                            })
                                        }
                                        isError={payload.true_up_date_q1.isError}
                                        error={payload.true_up_date_q1.error}
                                    />
                                </div>

                                <div className={`${pageClassName}__filter__item`}>
                                    <label>2nd True Up Date</label>
                                    <CustomDatePicker
                                        value={payload.true_up_date_q2.value ? new Date(payload.true_up_date_q2.value as string) : undefined}
                                        onChange={(date) =>
                                            setPayload({
                                                ...payload,
                                                true_up_date_q2: {
                                                    value: date?.toString() as string,
                                                    isError: false,
                                                    error: "",
                                                },
                                            })
                                        }
                                        isError={payload.true_up_date_q2.isError}
                                        error={payload.true_up_date_q2.error}
                                    />
                                </div>

                                <div className={`${pageClassName}__filter__item`}>
                                    <label>3rd True Up Date</label>
                                    <CustomDatePicker
                                        value={payload.true_up_date_q3.value ? new Date(payload.true_up_date_q3.value as string) : undefined}
                                        onChange={(date) =>
                                            setPayload({
                                                ...payload,
                                                true_up_date_q3: {
                                                    value: date?.toString() as string,
                                                    isError: false,
                                                    error: "",
                                                },
                                            })
                                        }
                                        isError={payload.true_up_date_q3.isError}
                                        error={payload.true_up_date_q3.error}
                                    />
                                </div>

                                <div className={`${pageClassName}__filter__item`}>
                                    <label>4th True Up Date</label>
                                    <CustomDatePicker
                                        value={payload.true_up_date_q4.value ? new Date(payload.true_up_date_q4.value as string) : undefined}
                                        onChange={(date) =>
                                            setPayload({
                                                ...payload,
                                                true_up_date_q4: {
                                                    value: date?.toString() as string,
                                                    isError: false,
                                                    error: "",
                                                },
                                            })
                                        }
                                        isError={payload.true_up_date_q4.isError}
                                        error={payload.true_up_date_q4.error}
                                    />
                                </div>
                            </>
                        )}

                        <Input
                            placeholder="Enter Number of Total Licenses"
                            label="Total Licenses"
                            onChange={(e) =>
                                setPayload({
                                    ...payload,
                                    total: {
                                        ...payload.total,
                                        value: parseInt(e.target.value),
                                        isError: false,
                                        error: "",
                                    },
                                })
                            }
                            value={(payload.total.value as number) || ""}
                            isError={payload.total.isError}
                            error={payload.total.error}
                            type="number"
                        />

                        <div className={`${pageClassName}__filter__item`}>
                            <label>Renewal Date</label>
                            <CustomDatePicker
                                value={payload.renewal_date.value ? new Date(payload.renewal_date.value as string) : undefined}
                                onChange={(date) =>
                                    setPayload({
                                        ...payload,
                                        renewal_date: {
                                            value: date?.toString() as string,
                                            isError: false,
                                            error: "",
                                        },
                                    })
                                }
                                isError={payload.renewal_date.isError}
                                error={payload.renewal_date.error}
                            />
                        </div>

                        <div className={`${pageClassName}__form__action`}>
                            <button
                                className={`${pageClassName}__form__action__button ${pageClassName}__form__action__cancel`}
                                onClick={() => navigate(-1)}
                                type="button"
                            >
                                Cancel
                            </button>
                            <button className={`${pageClassName}__form__action__button`} type="submit">
                                Save
                            </button>
                        </div>
                    </form>
                </Loader>
            </div>
        </div>
    );
}

export default AddNewSaaSTool;